import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { ApiUrls } from "./ApiUrls";
import { MatSnackBar } from "@angular/material/snack-bar";
import { InstallmentConfigurationInitFormResponseModel } from "../model/InstallmentConfigurationInitFormResponseModel";
import { InstallmentConfigurationLotteryInitFormResponseModel } from "../model/InstallmentConfigurationLotteryInitFormResponseModel";
import { InstallmentConfigurationSchemeInitFormResponseModel } from "../model/InstallmentConfigurationSchemeInitFormResponseModel";
import { LotteryInstallmentConfigurationModel } from "../model/LotteryInstallmentConfigurationModel";
import { SchemeInstallmentConfigurationModel } from "../model/SchemeInstallmentConfigurationModel";
import { ExtendAcceptanceInitFormResponseModel } from "../model/ExtendAcceptanceInitFormResponseModel";
import { Page } from "../model/Page";
import { TenementModal } from "../model/TenementModal";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class ExtendAcceptanceService {
  constructor(private httpClient: HttpClient, private _snackBar: MatSnackBar) {}

  initExtendAcceptanceForm() {
    return this.httpClient.get<ExtendAcceptanceInitFormResponseModel>(
      ApiUrls.extendAcceptanceInitFormUrl
    );
  }

  initWithLottery(lotteryKey: number) {
    return this.httpClient.get<ExtendAcceptanceInitFormResponseModel>(
      ApiUrls.extendAcceptanceInitWithLotteryUrl.replace(
        "{lotteryKey}",
        lotteryKey.toString()
      )
    );
  }


  getLotteryandSchemeData(page: number, size: number,lotteryKey: number,schemeKey:number,drawStatus:string, filterText?: string) {
    let reqParams =
      `?page=${page}&size=${size}` +
      (filterText ? `&filterText=${filterText}` : `&filterText=${null}`)+`&lotteryKey=${lotteryKey}&schemeKey=${schemeKey}&drawStatus=${drawStatus}`;
      //`?page=${page}&size=${size}&lotteryKey=${lotteryKey}&schemeKey=${schemeKey}&drawStatus=${drawStatus}`;
     //&filterText=${filterText}
    return this.httpClient.get<Page<TenementModal>>(
      ApiUrls.getLotteryandSchemeData +reqParams
    );
  }

  updateAcceptanceDtl(
    payload: TenementModal,
   
  ): Observable<object> {
    return this.httpClient.post<TenementModal>(
      ApiUrls.updateAcceptanceDtl,
      payload
    );
  }

  viewWithLottery(lotteryKey: number, installmentType: string) {
    return this.httpClient.get<InstallmentConfigurationLotteryInitFormResponseModel>(
      ApiUrls.viewinstallmentConfigInitWithLotteryUrl
        .replace("{lotteryKey}", lotteryKey.toString())
        .replace("{installmentType}", installmentType)
    );
  }
  viewWithScheme(
    lotteryKey: number,
    schemeKey: number,
    installmentType: string
  ) {
    return this.httpClient.get<InstallmentConfigurationSchemeInitFormResponseModel>(
      ApiUrls.viewinstallmentConfigInitWithSchemeUrl
        .replace("{lotteryKey}", lotteryKey.toString())
        .replace("{schemeKey}", schemeKey.toString())
        .replace("{installmentType}", installmentType)
    );
  }
  
  initWithScheme(lotteryKey: number, schemeKey: number) {
    return this.httpClient.get<InstallmentConfigurationSchemeInitFormResponseModel>(
      ApiUrls.installmentConfigInitWithSchemeUrl
        .replace("{lotteryKey}", lotteryKey.toString())
        .replace("{schemeKey}", schemeKey.toString())
    );
  }

  saveLotteryInstallmentConfiguration(
    lotteryKey: number,
    data: LotteryInstallmentConfigurationModel[]
  ) {
    return this.httpClient.post<{ status: string; errorMessage: string }>(
      ApiUrls.installmentConfigSaveWithLotteryUrl.replace(
        "{lotteryKey}",
        lotteryKey.toString()
      ),
      {
        lotteryInstallmentConfigs: data,
      }
    );
  }

  saveSchemeInstallmentConfiguration(
    lotteryKey: number,
    schemeKey: number,
    data: SchemeInstallmentConfigurationModel[]
  ) {
    return this.httpClient.post<{ status: string; errorMessage: string }>(
      ApiUrls.installmentConfigSaveWithSchemeUrl
        .replace("{lotteryKey}", lotteryKey.toString())
        .replace("{schemeKey}", schemeKey.toString()),
      {
        schemeInstallmentConfigs: data,
      }
    );
  }

  async successToast(msg) {
    await this._snackBar.open(msg, "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "success-toast",
      duration: 3 * 1000,
    });
  }

  async errorToast(errorMessage: string, dur?: number) {
    await this._snackBar.open(errorMessage, "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "error-toast",
      duration: dur ? dur : 3 * 1000,
    });
  }
}
